<template>
  <div v-if="loaded">
    <FormKit type="form" class="mt-4" :actions="false">
      <FormKit v-model="taskAttrs.name" type="text" label="Task Name" />
      <QuillInput
        :model-value="taskAttrs.description"
        label="Task Description"
        name="task-description"
        @update:model-value="value => (taskAttrs.description = value)"
      />
      <FormKit
        v-model="taskAttrs.assigned_to_role"
        type="select"
        label="Assigned to"
        :options="{ agent: 'Agent' }"
        placeholder="Select a person"
      />
    </FormKit>

    <Card extra-classes="bg-gray-100 mt-8">
      <h3 class="font-bold">Required Fields</h3>
      <p class="text-sm text-gray-600">We require the agent to fill out these fields.</p>
      <FormKit type="form" class="mt-4" :actions="false">
        <FormKit
          v-for="field in task.checklist_taskable?.settings?.humaniz_fields || []"
          :key="`humaniz-field-${field.key}`"
          type="checkbox"
          :name="field.key"
          :label="field.label"
          :value="true"
          :disabled="true"
        />
      </FormKit>
    </Card>

    <Card extra-classes="bg-gray-100 mt-2">
      <h3 class="font-bold">Custom Fields</h3>
      <p class="text-sm text-gray-600">Which of your custom fields do you want to collect from new agents?</p>
      <FormKit type="form" class="mt-4" :actions="false">
        <FormKit
          v-for="field in customFields"
          :key="`custom-field-${field.id}`"
          v-model="field.auto_collect_during_onboarding"
          type="checkbox"
          :name="`auto_collect_${field.id}`"
          :label="field.name"
          @input="updateCustomFieldSetting($event, field)"
        />
      </FormKit>
    </Card>
  </div>
</template>

<script>
import { Api } from '../../api/index.ts';
import Card from '../Card/index.vue';
import QuillInput from '../shared/QuillInput.vue';

export default {
  components: {
    Card,
    QuillInput,
  },
  props: {
    task: {
      required: true,
      type: Object,
    },
    assignableUsers: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      customFields: [],
      taskAttrs: {},
      loaded: false,
    };
  },
  async mounted() {
    await this.fetchCustomFields();
    this.taskAttrs = { ...this.task };
    console.log('Task data:', this.task);
    console.log('Humaniz fields:', this.task?.checklist_taskable?.settings?.humaniz_fields);
    this.loaded = true;
  },
  methods: {
    async updateCustomFieldSetting(value, field) {
      const body = { auto_collect_during_onboarding: value };
      await Api.CustomFields.updateCustomField({ id: field.id, body });
      // Update the local state to reflect the change immediately
      const index = this.customFields.findIndex(f => f.id === field.id);
      if (index !== -1) {
        this.customFields[index].auto_collect_during_onboarding = value;
      }
    },
    async fetchCustomFields() {
      const { records } = await Api.CustomFields.listCustomFieldsForEntity({
        entity: 'contact:teammate',
      });
      this.customFields = records;
    },
    async updateTask() {
      const res = await fetch(`/api/task_checklists/${this.task.task_checklist_id}/checklist_tasks/${this.task.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
        body: JSON.stringify({
          checklist_task: {
            name: this.taskAttrs.name,
            description: this.taskAttrs.description,
            assigned_to_role: this.taskAttrs.assigned_to_role,
            assigned_to_user_id: this.taskAttrs.assigned_to_user_id,
            order: this.taskAttrs.order,
          },
        }),
      });

      const { status } = await res.json();

      if (status === 'success') {
        const checklistType = this.task.task_checklist.checklist_type;
        await this.$router.push(`/settings/company/${checklistType}_checklists/${this.task.task_checklist_id}/edit`);
        this.$store.commit('general/showAlert', {
          alertType: 'success',
          alertTitle: 'Task Updated',
          alertDescription: 'Your task was successfully updated.  Use the button below to dismiss this alert.',
        });
      }
    },
  },
};
</script>
